import styles from "./ScreenTitle.module.css";

interface ScreenTitleProps {
    title: string;
}

/**
 * @author bakim
 * @date 2024-08-20
 * @remark 스크린 제목 컴포넌트
 * @param {string} title(required) : 스크린 제목
 */
function ScreenTitle(props: ScreenTitleProps) {
    return (
        <div className={styles.container}>
            <h2 className={styles.title}>{props.title}</h2>
        </div>
    );
}

export default ScreenTitle;
